var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('heads'),_c('transition',{attrs:{"name":_vm.transition.name}},[(_vm.$route.meta.cache === true)?_c('keep-alive',[_c('router-view')],1):_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }